<template>
  <div v-if="commentToEdit" class="edit-comment">
    <CommentInput
      ref="commentInput"
      v-model="commentToEdit"
      mode="update"
      @cancel="cancelEditMode"
      @comment="updateComment"
    />
  </div>

  <div v-else class="comment">
    <div :style="{ background: comment.created_by.color }" class="participant">
      {{ userInitials }}
    </div>

    <div class="body">
      <div class="details">
        <div class="name">
          {{ comment.created_by.name }}
          <span class="text-faded">{{ date }}</span>
        </div>

        <div class="actions">
          <q-icon
            v-if="hasPermissions"
            name="fas fa-pencil"
            color="tertiary"
            class="cursor-pointer q-mr-sm"
            @click="editClicked"
          />

          <q-icon
            v-if="hasPermissions"
            name="fas fa-trash"
            color="faded"
            class="cursor-pointer"
            @click="deleteComment"
          />
        </div>
      </div>
      <div class="text">{{ comment.body }}</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import * as apiTo from '../api'
// Components
import CommentInput from './CommentInput'

export default {
  components: {
    CommentInput
  },

  props: {
    comment: Object,
    todoId: Number,
    hasPermissions: Boolean
  },

  data: () => ({
    commentToEdit: null
  }),

  computed: {
    date() {
      const { updated_at, created_at } = this.comment
      let string = moment
        .tz(updated_at, this.settings.timezone)
        .local()
        .format('DD MMM YYYY H:mm')
      if (moment(updated_at).isAfter(moment(created_at))) string += ' (edited)'
      return string
    },

    userInitials() {
      const [name, lastName] = this.comment.created_by.name.split(' ')
      const nameFirstLetter = name ? name.slice(0, 1).toUpperCase() : ''
      const lastNameFirstLetter = lastName ? lastName.slice(0, 1).toUpperCase() : ''

      return nameFirstLetter + lastNameFirstLetter
    }
  },

  methods: {
    editClicked() {
      this.commentToEdit = this.comment.body
      this.$emit('edit-mode-changed', true)
      this.$nextTick(() => this.$refs.commentInput.focus())
    },

    cancelEditMode() {
      this.commentToEdit = ''
      this.$emit('edit-mode-changed', false)
    },

    updateComment() {
      apiTo
        .updateComment(this.todoId, this.comment.id, {
          body: this.commentToEdit
        })
        .then(({ data: { result: updatedComment } }) => {
          this.cancelEditMode()
          this.$emit('comment-updated', updatedComment)
        })
    },

    deleteComment() {
      apiTo.deleteComment(this.todoId, this.comment.id).then(() => this.$emit('comment-deleted'))
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.comment {
  display grid
  grid-template-columns auto 1fr
  justify-content start
  gap 10px

  .participant {
    border-radius 50%
    width 35px
    height 35px
    font-size 0.75rem
    display flex
    justify-content center
    align-items center
    border 2px solid white
    letter-spacing -1px
    color white
    font-weight 500
    cursor pointer
  }

  .body {
    display grid
    gap 5px

    .details {
      display grid
      grid-template-columns auto auto
      justify-content space-between
      align-items center

      .name {
        display grid
      }
    }
    .text {
      white-space pre-line
    }
  }

  .text-input {
    display grid
  }
}
</style>
